import React from 'react';
import './FloatingMenuArrow.scss';

export const FloatingMenuArrow = ({ hidden }: { hidden?: boolean }) => {
    return (
        <div className="arrow" hidden={hidden}>
            <svg
                width="28"
                height="14"
                viewBox="0 0 28 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path d="M14 0L28 14H0L14 0Z" fill="white" />
                <rect x="0" y="13" width="28" height="2" fill="white" />
            </svg>
        </div>
    );
};
